import 'whatwg-fetch';

function uriSerialize(obj) {
  var str = [];
  for(var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}


var lastTimeout;

var SuggestionSource = {

  verify: function (suggestion) {
    
    var requestBody = {
      'auth-id': '1489828000672374724',
      'license': 'us-core-enterprise-cloud',
      'match': 'enhanced',
      street: (typeof suggestion.street_line !== 'undefined' ? suggestion.street_line : ''),
      city: (typeof suggestion.city !== 'undefined' ? suggestion.city : ''),
      state: (typeof suggestion.state !== 'undefined' ? suggestion.state : ''),
      zipcode: (typeof suggestion.zipcode !== 'undefined' ? suggestion.zipcode : '')
    };
    // why is this not updating
    var promise = fetch('https://us-street.api.smartystreets.com/street-address?' + uriSerialize(requestBody))
      .then(function(response) {
        // why is this getting triggered when the promise is still pending, and unfulfilled?
        if(!response.ok) {
          throw Error(response.statusText); 
        }

        var json = response.json();
        return json;
      })
      .then(function(json) {
        return (json ? json : []);
      })
      .catch(function(ex) {
        console.log('catching exception', ex);
        return [];
      });
    
    return promise;
  }
};

export default  SuggestionSource;